import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import "./PartyPassPromotionModal.css";

function PartyPassPromotionModal({
  isOpen,
  toggle,
  onUnlockClick,
  title = "Skip Limit Reached",
  message = "Easy tiger, you are out of skips right now.",
  heading = "Get Unlimited Skips!",
  description = "Upgrade to Party Pass and skip as many videos as you want.",
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="party-pass-modal">
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody className="text-center">
        <p>
          {message}
        </p>
        <div className="party-pass-promotion">
          <h5>{heading}</h5>
          <p>
            {description}
          </p>
        </div>
      </ModalBody>
      <ModalFooter className="d-flex flex-column gap-2">
        <Button
          className="btn-unlock"
          onClick={onUnlockClick}
        >
          Unlock Party Pass
        </Button>
        <Button
          className="btn-later"
          onClick={toggle}
        >
          Maybe Later
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default PartyPassPromotionModal;
